import { Observable } from 'rxjs';

export abstract class NotesRepository {
    abstract createNote(uid: string, cid: string | null, data: any): Observable<any>;
    abstract getNotes(uid: string, cid: string | null): Observable<any>;
}
